module.exports = __webpack_public_path__ + "media/images/main-noregister-b89e10654ac5c4bb713a6c4bc1bbbb48.png";